import React from 'react';

const Divider = ({ style = {}, className = '' }) => {
  return (
    <div
      className={className}
      style={{
        width: '100%',
        borderTop: '1px solid black',
        ...style,
      }}
    ></div>
  );
};

export default Divider;
